import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, Fragment as _Fragment, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "mt-5" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "border-bottom mb-3" }
const _hoisted_7 = { class: "mb-3 row" }
const _hoisted_8 = { class: "col-md-8" }
const _hoisted_9 = { class: "d-grid gap-2 d-md-flex justify-content-md-end" }
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 0,
  class: "bi bi-info-circle-fill text-info"
}
const _hoisted_12 = {
  key: 1,
  class: "bi bi-info-circle-fill text-info"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["href"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 3 }
const _hoisted_21 = { key: 3 }
const _hoisted_22 = ["onClick"]

import {BTableColumn} from "../BTable/BTable.types";

import InformationModal from "../Misc/InformationModal.vue";
import AuditJobs from "./AuditJobs.vue";
import BGrid from "../BGrid/BGrid.vue";
import {onMounted, reactive, ref} from "vue";
import {useAuditIncidentStore} from "@/stores/auditIncidentStore";
import {object} from "yup";
import {Audit, AuditReviewDocument} from "@/audit.types";
import {useFormValidation} from "@/validation";
import {debounce} from "vue-debounce";


export default /*@__PURE__*/_defineComponent({
  __name: 'AuditDetailsIncidents',
  props: {
    id: {},
    audit: {},
    runAudits: { type: Boolean },
    createAudits: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

var updateData = debounce(() => getData(), "15000ms");

const isShowUploadNarrative = ref(false);
const selectedIncindentId = ref(0);
const uploadNarrativeTitle = ref("");
const isConfirmDialog = ref(false);
const canCheckIncidentsVersion = ref(false);
const auditIncidentStore = useAuditIncidentStore();

const hideUploadNarrative = () => {
    isShowUploadNarrative.value = false;
};

const showUploadNarrative = (incident) => {
    isShowUploadNarrative.value = true;
    selectedIncindentId.value = incident.id;
    uploadNarrativeTitle.value = `Upload Narrative for incident ${incident.incidentNumber}`;
    return false;
};

const columns = reactive<BTableColumn[]>([
    {
        key: "incidentNumber",
        text: "Incident Number",
        sortable: true,
        value: (item) => item["incidentNumber"],
    },
    {
        key: "incidentType",
        text: "Type",
        sortable: true,
        value: (item) => item.type,
    },
    {
        key: "incidentDate",
        text: "Incident/Arrest Date",
        sortable: true,
        value: (item) => item["date"],
    },
    {
        key: "status",
        text: "Status",
        sortable: false,
        value: (item) => item["statusName"],
    },
    {
        key: "actions",
        text: "",
        columnClass: ["text-end"],
        class: (item) => ["text-nowrap text-end"],
        sortable: false,
        value: (item) => 2,
    },
]);

const {handleSubmit, errors, resetValidation} = useFormValidation();
const uploadNarrative = ref<File | null>();
const isShowNarrativeReviewEditor = ref(false);

const showNarrativeReviewEditor = (id: number) => {
    resetValidation();
    review.value = {status: ""} as AuditReviewDocument;
    selectedIncindentId.value = id;
    isShowNarrativeReviewEditor.value = true;
};

const hideNarrativeReviewEditor = () => {
    isShowNarrativeReviewEditor.value = false;
};

const isShowIncidentReviewEditor = ref(false);

const showIncidentReviewEditor = (id: number) => {
    resetValidation();
    selectedIncindentId.value = id;
    review.value = {status: ""} as AuditReviewDocument;
    isShowIncidentReviewEditor.value = true;
};

const hideIncidentReviewEditor = () => {
    isShowIncidentReviewEditor.value = false;
};
const reviewIncident = async function () {
    if (await handleSubmit(reviewSchema, review.value)) {
        review.value.id = selectedIncindentId.value;
        await auditIncidentStore.reviewIncident(review.value);
        hideIncidentReviewEditor();
        await getData();
    }
};

const reviewSchema = object<AuditReviewDocument>({});

const review = ref({} as AuditReviewDocument);

const reviewNarrative = async function () {
    if (await handleSubmit(reviewSchema, review.value)) {
        review.value.id = selectedIncindentId.value;
        await auditIncidentStore.reviewNarrative(review.value);
        hideNarrativeReviewEditor();
        await getData();
    }
};

const checkIncidentsVersion = async () => {
    await auditIncidentStore.checkIncidentsVersion(props.id);
    await getData();
};

const hideConfirmDialog = async function () {
    isConfirmDialog.value = false;
};
const deleteIncident = async function () {
    await auditIncidentStore.deleteItem(selectedIncindentId.value);
    await getData();
    await hideConfirmDialog();
};
const deleteItem = async function (id: number) {
    selectedIncindentId.value = id;
    isConfirmDialog.value = true;
};

const getData = async () => {
    await auditIncidentStore.list(props.audit.id);
    await updateData();
};

const uploadDocument = async () => {
    await auditIncidentStore.uploadNarrative(selectedIncindentId.value, uploadNarrative);
    await getData();
    hideUploadNarrative();
    uploadNarrative.value.value = "";
};

onMounted(async () => {
    await getData();
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(InformationModal, {
      title: "Reject Narrative",
      "show-modal": isShowNarrativeReviewEditor.value,
      onDismiss: hideNarrativeReviewEditor
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(reviewNarrative, ["prevent"])
        }, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("div", _hoisted_2, [
              _cache[4] || (_cache[4] = _createElementVNode("label", {
                for: "reviewComment",
                class: "form-label"
              }, "Comment", -1)),
              _withDirectives(_createElementVNode("textarea", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((review.value.comment) = $event)),
                id: "reviewComment",
                class: "form-control"
              }, "                        ", 512), [
                [_vModelText, review.value.comment]
              ])
            ])
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "d-grid gap-2 d-md-flex justify-content-md-end" }, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary"
            }, " Reject ")
          ], -1))
        ], 32)
      ]),
      _: 1
    }, 8, ["show-modal"]),
    _createVNode(InformationModal, {
      title: "Review Incident",
      "show-modal": isShowIncidentReviewEditor.value,
      onDismiss: hideIncidentReviewEditor
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(reviewIncident, ["prevent"])
        }, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("div", _hoisted_3, [
              _cache[7] || (_cache[7] = _createElementVNode("label", {
                for: "reviewStatus",
                class: "form-label"
              }, "Status", -1)),
              _withDirectives(_createElementVNode("select", {
                id: "reviewStatus",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((review.value.status) = $event)),
                class: _normalizeClass(["form-select", {'is-invalid': !!_unref(errors).status}])
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("option", { value: "" }, "Select Status", -1),
                _createElementVNode("option", { value: "IF" }, "Reject Incident", -1),
                _createElementVNode("option", { value: "IP" }, "Accept Incident", -1)
              ]), 2), [
                [_vModelSelect, review.value.status]
              ]),
              (_unref(errors).status)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(errors).status), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[8] || (_cache[8] = _createElementVNode("label", {
                for: "reviewComment",
                class: "form-label"
              }, "Comment", -1)),
              _withDirectives(_createElementVNode("textarea", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((review.value.comment) = $event)),
                id: "reviewComment",
                class: "form-control"
              }, "                        ", 512), [
                [_vModelText, review.value.comment]
              ])
            ])
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "d-grid gap-2 d-md-flex justify-content-md-end" }, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary"
            }, " Save ")
          ], -1))
        ], 32)
      ]),
      _: 1
    }, 8, ["show-modal"]),
    _createVNode(InformationModal, {
      title: uploadNarrativeTitle.value,
      "show-modal": isShowUploadNarrative.value,
      onDismiss: hideUploadNarrative
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", null, [
          _createElementVNode("fieldset", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-md-3" }, [
                _createElementVNode("label", {
                  for: "uploadNarrative",
                  class: "col-form-label"
                }, "File:")
              ], -1)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("input", {
                  type: "file",
                  ref_key: "uploadNarrative",
                  ref: uploadNarrative,
                  id: "uploadNarrative",
                  class: "form-control"
                }, null, 512)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[11] || (_cache[11] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Cancel ", -1)),
            _createElementVNode("button", {
              onClick: _withModifiers(uploadDocument, ["prevent"]),
              class: "btn btn-primary",
              "data-bs-dismiss": "modal"
            }, " Save ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "show-modal"]),
    _createVNode(InformationModal, {
      title: "Delete",
      "show-modal": isConfirmDialog.value,
      "show-footer": true,
      className: "confirm",
      onDismiss: hideConfirmDialog
    }, {
      footer: _withCtx(() => [
        _cache[12] || (_cache[12] = _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          "data-bs-dismiss": "modal"
        }, " No ", -1)),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: deleteIncident
        }, " Yes ")
      ]),
      default: _withCtx(() => [
        _cache[13] || (_cache[13] = _createTextVNode(" Are You Sure? ", -1))
      ]),
      _: 1,
      __: [13]
    }, 8, ["show-modal"]),
    (_ctx.runAudits)
      ? (_openBlock(), _createBlock(AuditJobs, {
          key: 0,
          "run-audits": _ctx.runAudits,
          "create-audits": _ctx.createAudits,
          audit: _ctx.audit,
          id: _ctx.id
        }, null, 8, ["run-audits", "create-audits", "audit", "id"]))
      : _createCommentVNode("", true),
    _cache[14] || (_cache[14] = _createElementVNode("h2", null, "Incidents", -1)),
    _createVNode(BGrid, {
      caption: "List of jobs",
      tableOptions: _unref(auditIncidentStore).tableOptions,
      filterableFields: _unref(auditIncidentStore).filterableFields,
      filterOptions: _unref(auditIncidentStore).filterOptions,
      onOptionChange: getData,
      items: _unref(auditIncidentStore).items,
      columns: columns,
      loading: _unref(auditIncidentStore).loading
    }, _createSlots({
      "cell.incidentNumber": _withCtx(({item, column}) => [
        _createElementVNode("a", {
          target: "_blank",
          href: `MSIVReportViewer.aspx?IncidentNumber=${item.incidentNumber}&ORI=${item.ori}`
        }, _toDisplayString(item.incidentNumber), 9, _hoisted_10)
      ]),
      "cell.status": _withCtx(({item, column}) => [
        _createTextVNode(_toDisplayString(item.statusName) + " ", 1),
        (item.comment)
          ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_11, null, 512)), [
              [_directive_tooltip, item.comment]
            ])
          : (item.narrative && item.narrative.Comment)
            ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_12, null, 512)), [
                [_directive_tooltip, item.narrative.Comment]
              ])
            : _createCommentVNode("", true),
        (!item.loadId)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(" Deleted ")
            ], 64))
          : (item.actionLoadId && item.loadId != item.actionLoadId)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createTextVNode(" Updated ")
              ], 64))
            : _createCommentVNode("", true)
      ]),
      "cell.actions": _withCtx(({item, column}) => [
        (item.narrative == null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
              (item.status == 'NR' && !_ctx.runAudits)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-primary btn-sm",
                    onClick: _withModifiers(($event: any) => (showUploadNarrative(item)), ["prevent"])
                  }, " Upload Narrative ", 8, _hoisted_14))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("a", {
                class: "btn btn-sm btn-secondary ms-1",
                href: `api/v1/audit/file/${item.narrative.FileId}`
              }, "View Narrative", 8, _hoisted_15),
              (item.narrative.Status != 'DA' && !_ctx.runAudits)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-primary btn-sm ms-1",
                    onClick: _withModifiers(($event: any) => (showUploadNarrative(item)), ["prevent"])
                  }, " Replace Narrative ", 8, _hoisted_16))
                : _createCommentVNode("", true)
            ], 64)),
        (_ctx.runAudits && item.narrative)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (item.narrative.Status == 'DU' && item.status == 'IN')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-danger btn-sm ms-1",
                    onClick: _withModifiers(($event: any) => (showNarrativeReviewEditor(item.id)), ["prevent"])
                  }, " Reject Narrative ", 8, _hoisted_17))
                : _createCommentVNode("", true),
              (item.narrative.Status == 'DU' && item.status == 'IN')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-primary btn-sm ms-1",
                    onClick: _withModifiers(($event: any) => (showIncidentReviewEditor(item.id)), ["prevent"])
                  }, " Review Incident ", 8, _hoisted_18))
                : _createCommentVNode("", true),
              (item.status == 'IF' || item.status == 'IP')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn btn-primary btn-sm ms-1",
                    onClick: _withModifiers(($event: any) => (showIncidentReviewEditor(item.id)), ["prevent"])
                  }, " Update Review ", 8, _hoisted_19))
                : (_openBlock(), _createElementBlock("span", _hoisted_20))
            ], 64))
          : (_openBlock(), _createElementBlock("span", _hoisted_21)),
        (_ctx.runAudits)
          ? (_openBlock(), _createElementBlock("button", {
              key: 4,
              class: "btn btn-danger btn-sm ms-1",
              onClick: _withModifiers(($event: any) => (deleteItem(item.id)), ["prevent"])
            }, " Delete Request ", 8, _hoisted_22))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (canCheckIncidentsVersion.value)
        ? {
            name: "beforeFilter",
            fn: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (checkIncidentsVersion()), ["prevent"]))
              }, " Update Incident Versions ")
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["tableOptions", "filterableFields", "filterOptions", "items", "columns", "loading"])
  ]))
}
}

})